import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';

import Footer from '../components/Footer';
import Header from '../components/header/Header';

export default function NotValid() {
  const theme = useTheme();
  const { translatedText } = useContext(LocaleContext);

  interface BoxWrapperProps {
    children: React.ReactNode;
  }
  function BoxWrapper({ children }: BoxWrapperProps) {
    return (
      <Box
        width='25vw'
        height='200px'
        justifyContent='center'
        alignItems='center'
        display='flex'
        flexDirection='column'
        padding={4}
        border='1px solid'
        gap='15px'
        borderColor={theme.palette.sandShade2.main}
        borderRadius={2}
        boxShadow='0 1px 2px rgba(0,0,0,0.15)'
        sx={{
          '&:hover': {
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',

            transition: 'box-shadow 0.7s ease-in-out',
          },
          backgroundColor: theme.palette.sandShade1.main,
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box display='flex' flexDirection='column' height='100vh' width='100vw'>
      <Header />
      <Divider
        sx={{
          borderWidth: '1px',
          borderColor: theme.palette.sandShade3.main,
        }}
      />

      <Box display='flex' flex={1}>
        <Box
          width='100vw'
          marginTop='12%'
          display='flex'
          flexDirection='row'
          justifyContent='space-around'
        >
          <BoxWrapper>
            <Typography
              variant='h3'
              style={{
                margin: '1px',
                textAlign: 'center',
              }}
            >
              {translatedText.header.pendingMessage}
            </Typography>
          </BoxWrapper>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}
